/**
 * Root Saga - combines all sagas
 * Separated from index.ts to avoid circular dependencies
 */
import { all, fork } from 'redux-saga/effects';

// Sagas
import authSaga from './auth/sagas';
import rolesSaga from './roles/sagas';
import smsProvidersSaga from './smsProviders/sagas';
import invitesSaga from './invites/sagas';
import usersSaga from './users/sagas';
import companiesSaga from './companies/sagas';
import importSaga from './import/sagas';
import invoicesSaga from './invoices/sagas';
import customersSaga from './customers/sagas';
import notificationsSaga from './notifications/sagas';
import tasksSaga from './tasks/sagas';
import ticketsSaga from './tickets/sagas';
import commonSaga from './common/sagas';
import accessTokensSaga from './accessTokens/sagas';
import creditsSaga from './credits/sagas';
import dashboardsSaga from './dashboards/sagas';
import paymentsSaga from './payments/sagas';
import organisationsSaga from './organisations/sagas';
import paymentPlansSaga from './paymentPlans/sagas';
import conversationLineSaga from './conversationLine/sagas';
import remittanceAdvicesSaga from './remittanceAdvices/sagas';
import changesSaga from './changes/sagas';
import workflowsSaga from './workflow/sagas';
import reportSaga from './report/sagas';
import contentsSaga from './contents/sagas';
import supportTicketsSaga from './supportTickets/sagas';
import scheduledReportSaga from './scheduledReports/sagas';
import banksSaga from './banks/sagas';
import bankFileDescriptorsSaga from './bankFileDescriptors/sagas';
import customerPortalSaga from './customerPortal/sagas';
import salesOrdersSaga from './salesOrders/sagas';
import dataRecoverySaga from './dataRecovery/sagas';
import paymentBehaviourInsightsSaga from './paymentBehaviourInsights/sagas';
import webhookConfigurationSaga from './webhookConfiguration/sagas';

// Here we use `redux-saga` to trigger actions asynchronously. `redux-saga` uses something called a
// "generator function", which you can read about here:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/function*
export function* rootSaga() {
    yield all([
        fork(authSaga),
        fork(rolesSaga),
        fork(smsProvidersSaga),
        fork(invitesSaga),
        fork(usersSaga),
        fork(companiesSaga),
        fork(importSaga),
        fork(invoicesSaga),
        fork(customersSaga),
        fork(notificationsSaga),
        fork(tasksSaga),
        fork(ticketsSaga),
        fork(commonSaga),
        fork(accessTokensSaga),
        fork(creditsSaga),
        fork(dashboardsSaga),
        fork(paymentsSaga),
        fork(organisationsSaga),
        fork(paymentPlansSaga),
        fork(conversationLineSaga),
        fork(remittanceAdvicesSaga),
        fork(changesSaga),
        fork(workflowsSaga),
        fork(reportSaga),
        fork(scheduledReportSaga),
        fork(contentsSaga),
        fork(supportTicketsSaga),
        fork(banksSaga),
        fork(bankFileDescriptorsSaga),
        fork(customerPortalSaga),
        fork(salesOrdersSaga),
        fork(dataRecoverySaga),
        fork(paymentBehaviourInsightsSaga),
        fork(webhookConfigurationSaga)
    ]);
}
